/**
 * switchside - open the books sidebar from outside it.
 *
 * Founder, 3 Oct 2026: "the moment a new client is switched to it should auto
 * open the sidebar, because the logic is: when you choose a new client, what
 * option do you want to go to for him now". AppLayout decides WHEN (a switch to
 * another org, landing in Books with a sidebar to show); this only carries the
 * word to the Sidebar, which owns its collapsed state.
 *
 * Books only. Flow has no sidebar on any books (flowSidebar.ts, settled
 * 1 Oct 2026), and the founder kept that when this was asked for.
 */
export const SIDEBAR_OPEN_EVENT = 'karr:sidebar-open';

export function openSidebar(): void {
    window.dispatchEvent(new Event(SIDEBAR_OPEN_EVENT));
}
